import React, { useState, useEffect } from 'react';
import { Task } from '../../store/tasks/types';
import { autoId } from '../../utils/UidGenerator';
import { LanguagesBar } from '../LanguagesBar';
import TaskItem from './TaskItem';
import { ContainerProps } from './types';
import strings from '../../resources/strings';
import { Button } from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import './TasksContainer.scss';
import { validateLanguages, validateUrl } from '../../utils/Validator';
import SnackbarMessage from '../SnackbarMessage/SnackbarMessage';
import TaskTypes from '../../resources/enums/TaskTypes';
import { isEmpty } from 'lodash';

const TasksContainer: React.FC<ContainerProps> = (props) => {
    const [tasks, setTasks] = useState<Task[]>([]);
    const [error, setError] = useState(false);
    const [errorUrl, setErrorUrl] = useState(false);
    const [success, setSuccess] = useState(false);
    const [language, setLanguage] = useState('pl');

    const createNewItem = () => {
        return { id: autoId(), type: '', image: '', description: {} } as Task;
    };

    useEffect(() => {
        setTasks(props.tasks);
    }, [props.tasks]);

    const handleAddTask = () => {
        setTasks([...tasks, createNewItem()]);
    };

    const handleSubmit = () => {
        if (!validateLanguages(tasks, props.languages.length) || tasks.some((x) => isEmpty(x.description))) {
            setError(true);
            return;
        }
        const videoTasks: Task[] = tasks.filter(
            (task) => task.type === props.taskTypes.find((type) => type.type === TaskTypes.Video)?.id,
        );
        if (!validateUrl(videoTasks, props.languages)) {
            setErrorUrl(true);
            return;
        }
        props.handleSubmit(tasks);
        setSuccess(true);
    };

    return (
        <div className="tasks-outer-container">
            <LanguagesBar
                languages={props.languages}
                selectedLanguage={language}
                handleChange={setLanguage}
            ></LanguagesBar>
            <div className="tasks-inner-container">
                {tasks.map((task, index) => {
                    return (
                        <TaskItem
                            key={`taskItem-${index}`}
                            deleteEnabled={props.deleteEnabled}
                            deleteTask={props.deleteTask}
                            index={index}
                            task={task}
                            language={language}
                            languages={props.languages}
                            tasks={tasks}
                            setTasks={setTasks}
                            taskTypes={props.taskTypes}
                            skills={props.skills}
                        ></TaskItem>
                    );
                })}
                <Button className="add-task-btn" variant="outlined" onClick={handleAddTask}>
                    {strings.tasks.addTaskBtnLabel}
                </Button>
                <SnackbarMessage
                    serverity="error"
                    message={
                        error
                            ? strings.languagesValidation.errorMessage
                            : '' || errorUrl
                            ? strings.urlValidation.errorUrlMessage
                            : ''
                    }
                    clearMessage={() => {
                        setError(false);
                        setErrorUrl(false);
                    }}
                ></SnackbarMessage>
                <SnackbarMessage
                    serverity="success"
                    message={success ? strings.tasks.successMessage : ''}
                    clearMessage={() => {
                        setSuccess(false);
                    }}
                ></SnackbarMessage>
            </div>
            <div className="button-container">
                <Button
                    variant="outlined"
                    startIcon={<SaveIcon />}
                    sx={{ backgroundColor: '#E3F2FD', color: '#2196F3' }}
                    className="save-button"
                    type="button"
                    onClick={handleSubmit}
                >
                    {strings.newsAndEvents.buttons.save}
                </Button>
            </div>
        </div>
    );
};

export default TasksContainer;
